import React from "react"

import { Dropdown, Flex, Tag, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../../../Icon"

import "./styles.less"

const { Text } = Typography

// House outline pill (transparent fill + colored border/text). Colours per status match
// the Figma via app tokens: pending=orange, enrolled=green, unenrolled=neutral,
// rejected=red, needs_update=blue (styles in styles.less, keyed on the dr-<status> class).
export const RECEIPT_STATUS = {
  pending: { label: "Pending" },
  enrolled: { label: "Enrolled" },
  unenrolled: { label: "Unenrolled" },
  rejected: { label: "Rejected" },
  needs_update: { label: "Needs update", icon: "arrows_rotate" }
}

// Statuses an admin can switch a request to from the table cell.
const CHANGEABLE = ["pending", "enrolled", "unenrolled", "rejected"]

const StatusTag = ({ status, withDropdown, onChange }) => {
  const { t } = useTranslation()
  const meta = RECEIPT_STATUS[status] || { label: status }
  const editable = withDropdown && CHANGEABLE.includes(status)
  // "Needs update" is a filled light-blue badge (antd `processing`); the rest are
  // outline pills with a coloured border + text (see styles.less).
  const filled = status === "needs_update"

  const tag = (
    <Tag
      color={filled ? "processing" : undefined}
      className={`dr-status-tag ${filled ? "dr-filled" : "dr-outline"} dr-${status}`}
      style={{ margin: 0 }}
    >
      <Flex gap={4} align="center">
        {meta.icon ? <Icon type={meta.icon} style={{ fontSize: 16 }} /> : null}
        <Text>{t(meta.label)}</Text>
        {editable ? <Icon type="chevron_down_small" style={{ marginRight: -4 }} /> : null}
      </Flex>
    </Tag>
  )

  if (!editable) return tag

  return (
    <Dropdown
      trigger={["click"]}
      getPopupContainer={() => document.getElementById("main-layout")}
      menu={{
        items: CHANGEABLE.filter((s) => s !== status).map((s) => ({
          key: s,
          label: t(RECEIPT_STATUS[s].label)
        })),
        onClick: ({ key, domEvent }) => {
          domEvent.stopPropagation()
          onChange?.(key)
        }
      }}
    >
      <span onClick={(e) => e.stopPropagation()}>{tag}</span>
    </Dropdown>
  )
}

export default StatusTag
